import React from 'react'




type Props = {
    className?      : string
    size            : 9 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 20 | 28

    teamId          : ID

    onClick?        : callback
}


export default function TeamIcon(props:Props) {

    const classes = Classes("ui5-ico-{0} i5-team".f(props.size), props.className)

    return (
        <div className={classes}/>
    )

}
